import {useHistory} from 'react-router-dom'
import {setPathForRouter} from "@common-helpers/set-rout-path"

import {bemClassName} from 'bem-components-connector'

import React from 'react'

import './style.scss'

export const PageCounter = ({
                        withBtn = false,
                        currentPageNumber = 0,
                        pageQuantity = 0,
                        btnData = {}
                     }) => {

    const block = bemClassName('page-counter'),
          history = useHistory(),
          {prevRout, prevPageId, prevCallback} = btnData,
          clickHandler = () => {
            localStorage.setItem('duration', 'back')
            setPathForRouter(prevRout, prevPageId, false, history)
            typeof prevCallback === 'function' ? prevCallback() : null
          },
          language = localStorage.getItem('lang') 

    let text = 'Назад'

    if (language === 'eng'){
      text = 'Back'
    } else if (language === 'ger'){
        text = 'Zurück'
    } else if (language === 'fr'){
        text = 'Retour'
    } else if (language === 'it'){
        text = 'Indietro'
    }

    return (<div className={block()} >
        {withBtn ? <span className={block('btn')} onClick={clickHandler} >{text}</span> : null}
        <span className={block('text')}>{currentPageNumber}/{pageQuantity}</span>
    </div>)

}